import { createTheme, ThemeProvider } from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import CopyIcon from "@mui/icons-material/CopyAllOutlined";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const theme = createTheme({
  components: {
    MuiInputBase: {
      defaultProps: {
        size: "small",
      },
      variants: [
        {
          props: { size: "small", multiline: false },
          style: {
            height: 32,
            fontSize: 12,
          },
        },
        {
          props: { size: "small", multiline: true },
          style: {
            minHeight: 32,
            fontSize: 12,
          },
        },
      ],
      styleOverrides: {
        root: {
          backgroundColor: "white",
          borderRadius: 5,
          padding: 0,
          margin: 0,
        },
      },
    },
    MuiTableCell: {
      defaultProps: {
        padding: "none",
        align: "left",
      },
      styleOverrides: {
        root: {
          padding: "4px 0px",
          height: 32.5,
          paddingRight: 4,
          borderWidth: 0,
          fontSize: 14,
          color: "#595959",
          "&.header": {
            width: 100,
            fontWeight: 700,
          },
        },
      },
    },
  },
});

const FormattedQuoteForm = () => {
  return (
    <div
      style={{
        display: "flex",
        gap: 10,
        backgroundColor: "#F2F8FD",
        border: "3px solid #148DD3",
        padding: 10,
        borderRadius: 4,
      }}
    >
      <ThemeProvider theme={theme}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className="header">Price:</TableCell>
              <TableCell>
                <TextField size="small" />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="header">Quantity:</TableCell>
              <TableCell>5,000</TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="header">Product:</TableCell>
              <TableCell>Urea</TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="header">Mode:</TableCell>
              <TableCell>Truck</TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="header">Title transfer:</TableCell>
              <TableCell>Destination</TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="header">Ship window:</TableCell>
              <TableCell>
                <div>January 1, 2024</div>
                <div>to May 1, 2024</div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="header">Deliver to:</TableCell>
              <TableCell>IHOP, MO</TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="header" colSpan={2}>
                <div>Comments:</div>
                <TextField
                  disabled
                  multiline
                  rows={5}
                  fullWidth
                  value="Mauris sagittis consequat bibendum amet montes commodo aliquam
                  tellus. Viverra integer ut purus vestibulum mollis ut
                  dignissim. Nec quam mi eget diam. Et elit sed pulvinar in ut."
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={2}>
                <Button
                  id="formattedQuoteFormCopyButton"
                  variant="contained"
                  style={{ height: 32.5 }}
                  color="primary"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      "5,000 Urea Truck Destination January 1, 2024 to May 1, 2024 IHOP, MO"
                    );
                  }}
                >
                  <CopyIcon style={{ color: "white", fontSize: 22 }} />
                  COPY TO CLIPBOARD
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ThemeProvider>
    </div>
  );
};

export default FormattedQuoteForm;
